export default function addDefaultFieldValidatorMessages(field) {
  if (typeof field.required === 'boolean') {
    field.required = {
      value: field.required,
      message: `'${field.label ?? field.name ?? field.id ?? ''}' must be filled`.replace(
        /''/,
        'This field'
      ),
    };
  }
}
